import { render } from "./BreadCrumbs.vue?vue&type=template&id=8b61a648"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=8b61a648&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__